module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.29018/images/keyFeatures/buyer_intent_inbound.png"